<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    transition="dialog-bottom-transition"
    :overlay="false"
  >
  <v-card>
    <v-toolbar dark class="primary">
      <v-btn icon @click.native="transferChatFermer()" dark>
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title class="primary white--text subheading">{{ $t('toTransfer') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text fluid class="grey lighten-4">
      <v-layout row wrap>
        <v-flex xs12 class="dialogTransfert">
          <v-card flat class="heightDialogTransfert">
            <v-card-text class="contentDialogListeAgent">
              <v-flex xs12 class="ListeAgent">
                <div v-if="messageTransfereStatus.automatique">
                  {{ $t('messageAgentIndispo')}}
                </div>
                <div v-else>{{ $t('selectAgentToTransfer') }}</div>
                <br />
                <wz-list-agents
                  :agentSelect.sync="selectedAgent"
                  :inMonitoring="false"
                  :visiteurSiteID="datasVisiteur.siteID"
                ></wz-list-agents>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-card flat class="heightDialogTransfertBT">
            <v-card-text>
              <v-flex xs12>
                <div
                  class="wz_txtTopBtnTransfere"
                  v-if="selectedAgent.id !== '' && selectedAgent.status === 'online'"
                  v-html="$tc('agentSelectedSupport', 0, {count: selectedAgent.name})"
                ></div>
                <div
                  class="wz_txtTopBtnTransfere"
                  v-else-if="selectedAgent.id !== '' && selectedAgent.status !== 'online'"
                  v-html="$tc('agentNotAvailableSupport', 0, {count: selectedAgent.name})"
                ></div>
                <div
                  class="wz_txtTopBtnTransfere"
                  v-else
                >{{ $tc('agents', 0) }}</div>
              </v-flex>
              <v-flex xs12>
                <v-btn
                  v-if="selectedAgent.status === 'online'"
                  color="primary"
                  dark
                  :loading="loadingDialog"
                  @click="transferChat()"
                >{{ $t('toTransfer') }}</v-btn>
                <v-btn
                  color="primary"
                  v-else-if="selectedAgent.status !== 'online'"
                  light
                  disabled
                >{{ $t('toTransfer') }}</v-btn>
                <v-btn
                  color="primary"
                  v-else
                  light
                  disabled
                >{{ $t('toTransfer') }}</v-btn>
                <v-btn
                  v-if="messageTransfereStatus.status === 'wait'"
                  color="primary"
                  dark
                  @click="annuleTransfer()"
                >{{ $t('cancel') }}</v-btn>
              </v-flex>
              <!--
              <v-flex xs12 v-if="messageTransfereStatus.status === 'wait'">
                {{ messageTransfereStatus.message }}
              </v-flex>
              -->
              <v-flex xs12 v-if="messageTransfereStatus.status === 'no'">
                <v-icon medium color="orange darken-2">warning</v-icon>{{messageTransfereStatus.message }}
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog> 
</template>

<script>
import _ from 'lodash'
import _watcheebox from '../watcheebox/watcheebox.js'
import { mapGetters, mapState, mapActions } from 'vuex'
export default {
  props: {
    datasVisiteur: {
      type: Object,
      required: true
    },
    openOnMounted: {
      type: Boolean
    }
  },
  data () {
    return {
      selectedAgent: {},
      dialog: false,
      messageTransfereStatus: {
        'status': '',
        'automatique': '',
        'visiteurSelected': '',
        'message': ''
      }
    }
  },

  mounted () {
    console.log('this.openOnMounted', this.openOnMounted)
    if (this.openOnMounted) {
      // if (this.WATCHEEBOX_STATE.transfertStatusEmission.status === 'wait') {
      this.open()
      // }
    }
  },

  computed: {
    ...mapState('_StoreWatcheeBox', ['agentsArray', 'transfertStatusEmission']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapGetters('_User', ['fullName']),
    loadingDialog () {
      if (this.messageTransfereStatus.status === 'wait') {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapActions('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT']),
    // Actions de transfere de chat vers un autre agent dispo
    transferChat () {
      // si un agent est selectionné dans la liste
      if (this.selectedAgent.id !== '') {
        // il faut recuperer toutes les données visiteur pour le transfere
        var datasVisiteurSelect = {
          socketID: this.datasVisiteur.socketID,
          visiteurID: this.datasVisiteur.visiteurID,
          visiteurKey: this.datasVisiteur.roomName,
          siteID: this.datasVisiteur.siteID
        }
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID
        _watcheebox.SendTransfertVisitor({
          selectedAgent: this.selectedAgent,
          datasSelectedVisiteur: datasVisiteurSelect,
          agentsArray: this.agentsArray,
          // 'socket': this.$socket,
          myAgentID: this.$store.state._User.id,
          mySocketID: mySocketID,
          agentSenderName: this.fullName,
          automatique: false
        })
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message:
            'Selectionnez un agent dans la liste avant de transferer ce visiteur',
          context: 'warning'
        })
      }
    },

    open () {
      this.dialog = true
      // si il y a un transfere en attente
      if (this.WATCHEEBOX_STATE.transfertStatusEmission.status === 'wait') {
        // recherche le status de l'agent selectionné
        let statusAgentSelect = 'offline'
        _.forEach(this.agentsArray, (agent, key) => {
          if (agent[2] === this.WATCHEEBOX_STATE.transfertStatusEmission.datas.WZAgentId) {
            statusAgentSelect = agent[3]
          }
        })
        console.log('il y a un transfere en attente')
        this.selectedAgent = {
          id: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.WZAgentId,
          name: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.agentName,
          socketID: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.destAgentSocket,
          status: statusAgentSelect
        }
        this.messageTransfereStatus = {
          status: this.WATCHEEBOX_STATE.transfertStatusEmission.status,
          automatique: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.automatique,
          visiteurSelected: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.chatSession,
          message: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.msg
        }
      }
    },

    // annule le transfert sans fermer la fenetre
    annuleTransfer () {
      this.transferChatAnnuler()
    },

    // ferme la fenetre et annule le transfert
    transferChatFermer () {
      this.transferChatAnnuler()
      this.$emit('closeDialog')
    },

    // Annule le transfert avec l'autre agent
    transferChatAnnuler () {
      var mySocketID = this.WATCHEEBOX_STATE.mySocketID
      _watcheebox.AnnulTransfertVisitor({
        selectedAgent: this.selectedAgent,
        mySocketID: mySocketID,
        agentSenderName: this.fullName
      })
      // this.$store.commit('_StoreWatcheeBox/SET_TRANSFERE_STATUS', '')
      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: '',
        emission: true,
        messageDatas: ''
      })
    }
  },

  watch: {
     // ----------------------------------------------------------------------------
    // status du transfere de chat
    // ----------------------------------------------------------------------------
    'transfertStatusEmission': function (val, oldval) {
      console.log('--transfertStatusEmission--', val.status)
      // attente de la reponse d'un agent
      if (val.status === 'wait') {
        this.transfertActif = val.datas.chatSession
        this.messageTransfereStatus.status = 'wait'
        this.messageTransfereStatus.automatique = val.datas.automatique
        this.messageTransfereStatus.chatSession = val.datas.chatSession
        this.messageTransfereStatus.message = this.$t('transfertWait')
      // transfere accepté par l'agent
      } else if (val.status === 'ok') {
        this.transfertActif = false
        // var visiteur = false
        this.messageTransfereStatus.status = 'ok'
        this.messageTransfereStatus.automatique = val.datas.automatique
        this.messageTransfereStatus.chatSession = val.datas.chatSession
        this.messageTransfereStatus.message = this.$t('transfertOk') + ' ' + val.datas.chatSession
        // close le chat
        this.ACTION_CLOSE_CHAT({
          formulaireSatisfaction: false,
          datasVisiteur: this.datasVisiteur,
          clotureChat: false,
          fullPath: this.$route.fullPath,
          textNotif: this.messageTransfereStatus.message
        })

        // Notification
        // this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.messageTransfereStatus.message, context: 'success' })

      // transfere refuser par l'agent
      } else if (val.status === 'no') {
        this.transfertActif = val.datas.chatSession
        this.messageTransfereStatus.status = 'no'
        this.messageTransfereStatus.automatique = ''
        this.messageTransfereStatus.chatSession = val.datas.chatSession
        this.messageTransfereStatus.message = this.$t('transfertNo')
      } else if (val.status === 'annuler') {
        // console.log('transfer annuler')
        this.transfertActif = false
        this.messageTransfereStatus.status = 'annuler'
        this.messageTransfereStatus.automatique = ''
        this.messageTransfereStatus.chatSession = ''
        this.messageTransfereStatus.message = ''
      } else {
        this.transfertActif = false
        this.messageTransfereStatus.status = ''
        this.messageTransfereStatus.automatique = ''
        this.messageTransfereStatus.chatSession = ''
        this.messageTransfereStatus.message = ''
      }
    },

    dialog: function (v) {
      if (!v) {
        this.$emit('closeDialog')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzDialogTransfertChat.vue